import { render, staticRenderFns } from "./PageAccessPassword.vue?vue&type=template&id=73da7068&scoped=true&"
import script from "./PageAccessPassword.vue?vue&type=script&lang=js&"
export * from "./PageAccessPassword.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessPassword.vue?vue&type=style&index=0&id=73da7068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da7068",
  null
  
)

export default component.exports